/**
 * Initialize amount input controls with increment/decrement buttons
 * Looks for `.js-amount` container and controls within it
 */
export default function initAmountInput() {
  const quantityContainer = document.querySelector('.js-amount');

  if (!quantityContainer) {
    return;
  }

  const minusBtn = quantityContainer.querySelector('.js-amount__btn--minus');
  const plusBtn = quantityContainer.querySelector('.js-amount__btn--plus');
  const input = quantityContainer.querySelector('.js-amount__input');

  if (!minusBtn || !plusBtn || !input) {
    return;
  }

  const updateButtonStates = () => {
    const value = parseInt(input.value);
    minusBtn.disabled = value <= 1;
    plusBtn.disabled = value >= parseInt(input.max);
  };

  const decreaseValue = () => {
    input.stepDown();
    updateButtonStates();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const increaseValue = () => {
    input.stepUp();
    updateButtonStates();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  updateButtonStates();

  input.addEventListener('input', updateButtonStates);
  minusBtn.addEventListener('click', decreaseValue);
  plusBtn.addEventListener('click', increaseValue);

  // Tier prices buttons are setting amount value directly
  const tierBtns = document.querySelectorAll('.js-tier-btn');
  if (tierBtns.length > 0) {
    const onTierBtnClick = (event) => {
      const btn = event.currentTarget;

      if (btn.classList.contains('active')) {
        tierBtns.forEach((b) => b.classList.remove('active'));
        input.value = 1;
      } else {
        const amount = parseInt(btn.dataset.amount, 10) || 1;
        input.value = amount;
      }

      updateButtonStates();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    Array.from(tierBtns).forEach((btn) => {
      btn.addEventListener('click', onTierBtnClick);
    });
  }
}
